import type { ObjectClass } from '@/type';

/**
 * 사용 가능한 extendClass를 기반으로 SuperClass 리스트를 필터링합니다.
 */
export const filterSuperClassList = (
  allSuperClassList:
    | (ObjectClass & { extendClass?: ObjectClass[] })[]
    | null
    | undefined,
  availableExtendClasses: ObjectClass[] | null | undefined,
): (ObjectClass & { extendClass?: ObjectClass[] })[] => {
  if (!allSuperClassList || !availableExtendClasses) return [];

  return allSuperClassList
    .filter(superClass =>
      availableExtendClasses.some(
        extend =>
          extend.id === superClass.id || extend.parentID === superClass.id,
      ),
    )
    .map(item => ({
      ...item,
      extendClass: item.extendClass?.filter(availableExtend =>
        availableExtendClasses.some(extend => extend.id === availableExtend.id),
      ),
    }));
};
